import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 15h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v3","key":"svg-0"}],["path",{"d":"M12 19h-4a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v2.5","key":"svg-1"}],["path",{"d":"M15.914 13.417a2 2 0 1 0 -2.447 2.511","key":"svg-2"}],["path",{"d":"M16 19h6","key":"svg-3"}],["path",{"d":"M19 16l-3 3l3 3","key":"svg-4"}]]

const IconCashMoveBack = createReactComponent('outline', 'cash-move-back', 'CashMoveBack', __iconNode);

export default IconCashMoveBack;